<div class="notification-toast" *ngIf="showToast">
    <div class="toast-container">
        <div [ngClass]="toastIconCss[toastType]">
            <img [src]="toastIcon[toastType]">
        </div>
        <div class="notification-toast__content">
            <div class="notification-title">{{translationToastMessage['toastMessage.'+toastType]}}</div>
            <div class="notification-description">
                {{desciption}}
            </div>
        </div>
        <div class="toast-close">
            <img src="img/cancelIcon.svg" (click)="closeToast()">
        </div>
    </div>
</div>